import { gql } from '@apollo/client'

export const EMPLOYEE_PREFERENCES = gql`
    query employeePreferences {
        employeeInfo {
            preferences {
                designVersion
                expandedSidebar
                favoritesOpen
                favorites {
                    id
                    label
                    route
                    iconType
                }
            }
        }
    }
`
